
export default [
  {
    path: "scientificCenter",
    name: "scientificCenter",
    component: () => import("@/views/scientificCenter/scientificCenter"),
  },
  
]